/**
 * Applica in carrello lo sconto quantità del configuratore.
 * Gli scaglioni viaggiano nella proprietà riga "_Fasce sconto" (es. "100:20,200:22").
 * Il codice HGQ{productId}Q{minQty} è uno sconto Shopify sul prodotto, con quantità minima.
 */
(function () {
  var CODE_RE = /^HGQ(\d+)Q(\d+)$/i;
  var rejected = {};
  var timer = null;
  var syncing = false;

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + path;
  }

  function parseTiers(raw) {
    var tiers = [];
    String(raw || '').split(',').forEach(function (part) {
      var bits = part.split(':');
      if (bits.length < 2) return;
      var minQty = parseInt(bits[0], 10);
      var pct = parseFloat(bits[1]);
      if (!isNaN(minQty) && minQty > 0 && !isNaN(pct) && pct > 0) {
        tiers.push({ minQty: minQty, pct: pct });
      }
    });
    return tiers;
  }

  function bestTier(qty, tiers) {
    var best = null;
    tiers.forEach(function (t) {
      if (qty >= t.minQty && (!best || t.minQty >= best.minQty)) best = t;
    });
    return best;
  }

  function discountCode(productId, minQty) {
    return 'HGQ' + productId + 'Q' + minQty;
  }

  function desiredCodes(cart) {
    var groups = {};
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props.Tipo === 'Costo personalizzazione') return;
      var fasce = props['_Fasce sconto'];
      if (!fasce || !item.product_id) return;
      var id = String(item.product_id);
      if (!groups[id]) groups[id] = { qty: 0, tiers: parseTiers(fasce) };
      groups[id].qty += item.quantity || 0;
      if (!groups[id].tiers.length) groups[id].tiers = parseTiers(fasce);
    });
    var codes = [];
    Object.keys(groups).forEach(function (id) {
      var tier = bestTier(groups[id].qty, groups[id].tiers);
      if (!tier) return;
      var code = discountCode(id, tier.minQty);
      if (rejected[code.toUpperCase()]) return;
      codes.push(code);
    });
    return codes;
  }

  function sameCodes(a, b) {
    var aa = a.map(function (c) { return c.toUpperCase(); }).sort();
    var bb = b.map(function (c) { return c.toUpperCase(); }).sort();
    if (aa.length !== bb.length) return false;
    for (var i = 0; i < aa.length; i++) if (aa[i] !== bb[i]) return false;
    return true;
  }

  function refreshDrawer() {
    try {
      if (typeof ajaxCart === 'object' && ajaxCart && typeof ajaxCart.load === 'function') ajaxCart.load();
    } catch (e) {}
  }

  function syncQuantityDiscounts() {
    if (syncing) return Promise.resolve();
    syncing = true;
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var current = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        var managed = [];
        var other = [];
        current.forEach(function (code) {
          if (CODE_RE.test(code)) managed.push(code);
          else other.push(code);
        });
        var desired = desiredCodes(cart);
        var next = other.concat(desired);
        if (sameCodes(current, next)) return null;
        return fetch(cartUrl('cart/update.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-PC-Discount-Sync': '1'
          },
          body: JSON.stringify({ discount: next.join(',') })
        }).then(function (res) { return res.json(); });
      })
      .then(function (updated) {
        if (!updated || !updated.discount_codes) return;
        var changed = false;
        updated.discount_codes.forEach(function (d) {
          if (d && d.code && CODE_RE.test(d.code) && d.applicable === false) {
            rejected[d.code.toUpperCase()] = true;
            changed = true;
          }
        });
        refreshDrawer();
        if (changed) {
          syncing = false;
          return syncQuantityDiscounts();
        }
      })
      .catch(function () {})
      .then(function () { syncing = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { syncQuantityDiscounts(); }, 350);
  }

  window.pcSyncQuantityDiscounts = syncQuantityDiscounts;

  if (window.fetch && !window.__pcQtyDiscountFetch) {
    window.__pcQtyDiscountFetch = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var pending = orig.apply(this, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var headers = (init && init.headers) || {};
      var mark = headers['X-PC-Discount-Sync'] || headers['x-pc-discount-sync'];
      if (!mark && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        pending.then(function () { schedule(); }, function () {});
      }
      return pending;
    };
  }
})();
